import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { ApiContainer } from "../utils/api";
import { SET_API_DATA } from "../redux/constants";

const waiversFormContainer = () => {
  const { api } = ApiContainer();
  const { waiver_id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const waiversResult = useSelector((state) => state.api.waiversResult);
  const waiversLoader = useSelector(
    (state) => state.api?.loader?.waiversResult
  );

  const waiverFormData = useSelector((state) => state.api.waiverFormData);
  const waiversFormLoader = useSelector(
    (state) => state.api?.loader?.waiverFormData
  );

  const [initialFormData, setInitialFormData] = useState({});
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [selectedMenu, setSelectedMenu] = useState(
    queryParams?.get("category") || "Overview"
  );

  const isFormChanged =
    JSON.stringify(formData) !== JSON.stringify(initialFormData);

  const handleChange = (fieldKey, value) => {
    setFormData((prev) => ({ ...prev, [fieldKey]: value }));
    setErrors((prev) => ({ ...prev, [fieldKey]: "" }));
  };

  const formatFieldName = (key = "") => {
    if (!key) return "This field";
    return key.replace(/_/g, " ").replace(/\d+/g, "").trim();
  };

  const validateForm = () => {
    const newErrors = {};

    waiverFormData?.content?.forEach((field) => {
      const value = formData[field.key];
      const formattedFieldName = formatFieldName(field.key);

      if (["textbox", "number"].includes(field.type) && !value) {
        newErrors[field.key] = `${formattedFieldName} is required`;
      }

      if (field.type === "datepicker") {
        if (!value || !dayjs(value).isValid()) {
          newErrors[field.key] = `${formattedFieldName} is required`;
        }
      }

      if (field.type === "time") {
        if (!value || !dayjs(value, "HH:mm").isValid()) {
          newErrors[field.key] = `${formattedFieldName} is required`;
        }
      }

      if (field.type === "checkbox" && !value) {
        newErrors[field.key] = `You must agree  ${formattedFieldName}`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    const {
      signature_status,
      images,
      content,
      waiver_name,
      id,
      ...filteredFormData
    } = formData;

    if (validateForm()) {
      const SubmitData = await api({
        method: "POST",
        endPoint: `waiver/${waiver_id}`,
        data: filteredFormData,
        showToastMessage: true,
        urlencoded: false,
        needLoader: true,
        parent: "waiverFormData",
      });

      if (SubmitData?.status) {
        if (selectedMenu === "fromTeam") {
          navigate(`/teams/join`);
        } else navigate(`/edit-profile?activeTab=Waivers`);
      }
    }
  };

  const handleCancle = () => navigate(`/edit-profile?activeTab=Waivers`);

  const handleWaiversClick = async (data) => {
    if (data) {
      const waiverData = await api({
        method: "GET",
        endPoint: `/waiver/${data}`,
        showToastMessage: false,
        urlencoded: false,
        needLoader: true,
        parent: "waiverFormData",
        needFullResponse: false,
      });
      if (waiverData?.status) {
        dispatch({
          type: SET_API_DATA,
          payload: {
            waiverFormData: waiverData?.data,
          },
        });
        setInitialFormData(waiverData?.data || {});
        setFormData(waiverData?.data || {});
        navigate(`/edit-profile/waivers-form/${data}`);
      }
    }
  };

  useEffect(() => {
    setFormData({});
    handleWaiversClick(waiver_id);
  }, [waiver_id]);

  return {
    waiversResult,
    waiversLoader,
    handleWaiversClick,
    waiverFormData,
    waiversFormLoader,
    formData,
    errors,
    handleSubmit,
    handleChange,
    handleCancle,
    isFormChanged,
  };
};

export default waiversFormContainer;
